import * as SmartySDK from "smartystreets-javascript-sdk";

import { SMARTY_EMBEDDED_KEY } from "@shared/constants";

import { logError } from "@shared/functions/log";

export interface ValuesType {
  oneLineAddress: string;
  streetAddress: string;
  city: string;
  state: string;
  zipCode: string;
  zipCodeValid?: boolean;
  streetLine?: string;
  zipcode?: string;
  secondary?: never;
  entries?: never;
}

type alternateCountiesObjectType = {
  countyFips: string;
  countyName: string;
  state: string;
  stateAbbreviation: string;
};

type citiesObjectType = {
  city: string;
  mailableCity: boolean;
  state: string;
  stateAbbreviation: string;
};

const SmartyCore = SmartySDK.core;
const smartySharedCredentials = new SmartyCore.SharedCredentials(
  SMARTY_EMBEDDED_KEY,
);

export const client = new SmartyCore.ClientBuilder(smartySharedCredentials)
  .withLicenses(["us-autocomplete-pro-cloud"])
  .buildUsAutocompleteProClient();

export function createUSLookup(query: string, hasSecondaries: boolean) {
  const lookup = new SmartySDK.usAutocompletePro.Lookup(query);
  lookup.maxResults = 5;

  // Specifies the percentage of address suggestions that should be preferred (in this case, those using geolocation) and will appear at the top of the suggestion list.
  lookup.preferRatio = 40;
  if (hasSecondaries) {
    lookup.selected = query;
  }
  return lookup;
}

export function determineSaveValues(
  alternateCounties: alternateCountiesObjectType[],
  cities: citiesObjectType[],
) {
  const mailableCities = cities.filter((city) => city.mailableCity);

  if (mailableCities.length !== 1) {
    return false;
  } else {
    const defaultState = cities[0].state;
    let saveValues = true;
    alternateCounties.forEach((county) => {
      if (county.state !== defaultState) {
        saveValues = false;
      }
    });
    return saveValues;
  }
}

export function createZipCodeLookup(query: string) {
  const zipCodeLookup = SmartySDK.usZipcode.Lookup;
  const zipCodeClient = new SmartyCore.ClientBuilder(
    smartySharedCredentials,
  ).buildUsZipcodeClient();

  const lookup = new zipCodeLookup();
  lookup.zipCode = query;

  return zipCodeClient.send(lookup).catch((result) => {
    logError({
      message: "Zip Code Lookup Failed",
      error: result.error,
    });
    return result;
  });
}

export function formatAutocompleteSuggestion(
  suggestion: SmartySDK.usAutocompletePro.Suggestion | ValuesType,
  multipleEntries: boolean = false,
) {
  const street = suggestion.streetLine ? `${suggestion.streetLine}` : "";
  const secondary = suggestion?.secondary ? ` ${suggestion.secondary}` : "";
  const entries = suggestion?.entries !== 0 ? ` (${suggestion.entries})` : "";
  const city = suggestion?.city ? `${suggestion.city}, ` : "";
  const state = suggestion?.state ? `${suggestion.state} ` : "";
  const zip = suggestion?.zipcode ? `${suggestion.zipcode}` : "";

  if (multipleEntries) {
    return street + secondary + entries + ", " + city + state + zip;
  } else {
    return street + secondary + ", " + city + state + zip;
  }
}
